import type { ITheme } from "./contexts/ThemeContext";

// Option B: Eco-Modern palette
const primary = '#0E5A3A';      // deep forest
const secondary = '#0F766E';     // teal
const accent = '#F4B73D';        // sun / sand
const highlight = '#38BDF8';     // sky
const feature = '#7C3AED';       // violet

const ink = '#2a5242';
const bg = '#F6F7FB';
const surface = '#FFFFFF';
const surfaceAlt = '#F0F4F8';
const border = '#E6E8EF';

const text = ink;
const textMuted = '#64748B';

// Gradients
const heroGradient = `linear-gradient(135deg, ${primary}15 0%, ${secondary}12 50%, ${highlight}10 100%)`;
const sectionGradientA = `linear-gradient(180deg, ${bg} 0%, ${surface} 100%)`;
const sectionGradientB = `linear-gradient(180deg, ${surfaceAlt} 0%, ${primary}08 100%)`;
const buttonGradient = `linear-gradient(135deg, ${primary} 0%, ${secondary} 100%)`;

export const theme: ITheme = {
    palette: {
        primary: {
            main: primary,
            light: '#1A7A4A',
            dark: '#0A3A25',
            contrastText: surface,
        },
        secondary: {
            main: secondary,
            light: '#1A8A7E',
            dark: '#0A4A45',
            contrastText: surface,
        },
        error: {
            main: 'rgb(255, 0, 0)',
            light: 'rgb(255, 57, 57)',
            dark: 'rgb(200, 0, 0)',
            contrastText: 'rgb(0, 0, 0)',
        },
        success: {
            main: primary,
            light: '#1A7A4A',
            dark: '#0A3A25',
            contrastText: surface,
        },
        divider: border
    },
    background: {
        default: bg,
        paper: surfaceAlt,
        panel: surfaceAlt,
        card: surface,
    },
    text: {
        primary: text,
        secondary: textMuted,
        disabled: '#CCCCCC',
        muted: textMuted,
        contrast: surface,
    },
    colors: {
        primary,
        secondary,
        accent,
        highlight,
        feature,
        ink,
        text,
        textMuted,
        bg,
        surface,
        surfaceAlt,
        border,
        // Legacy support
        green: {
            g1: primary,
            g2: secondary,
            g3: '#0A3A25',
        },
        accentLegacy: {
            korea: secondary,
            egypt: accent,
        },
        line: border,
    },
    gradients: {
        hero: heroGradient,
        sectionA: sectionGradientA,
        sectionB: sectionGradientB,
        button: buttonGradient,
    },
    borderRadius: {
        r1: '16px',
        r2: '22px',
    },
    shadow: {
        shadow1: '0 4px 12px rgba(0,0,0,0.1)',
        cardShadow: '0 2px 8px rgba(0,0,0,0.08)',
        hoverShadow: '0 8px 24px rgba(14, 90, 58, 0.15)',
    }
}